import { AppLayout } from '../shell/AppLayout';

// Mobile layout: uses desktop layout as fallback until mobile UI is implemented
export const MobileLayout = AppLayout;
